import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FiltrosExclusion, IBusqueda, ICategoriaAsignatura, IDescarga, IExclusionAsignaturaBody, IExclusionAsignaturaRes, IGuardar, ISeccion, ISedes, ISiglaAsignatura, ITipoAsignatura } from 'src/app/interfaces/exclusion-asignatura';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ExclusionService {
  constructor(
    private http: HttpClient
  ) { }
  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getSedes(usuarioId: number, anyo: number, periodoId: number):Observable<ISedes> {
    const url = `${environment.endpointAdministrativo}/v1/exclusion-asignatura/obtener-sedes?usuario-id=${usuarioId}&anyo=${anyo}&periodo-id=${periodoId}`;
    return this.http.get<ISedes>(url, {headers: this.getHeaders()});
  }
  getTipoAsignatura(anyo: number, periodoId: number,sedeId: number): Observable<ITipoAsignatura> {
    const url = `${environment.endpointAdministrativo}/v1/exclusion-asignatura/buscar-tipo-asignatura?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}`;
    return this.http.get<ITipoAsignatura>(url, {headers: this.getHeaders()});
  }
  getCategoriasAsignatura(): Observable<ICategoriaAsignatura> {
    const url = `${environment.endpointAdministrativo}/v1/exclusion-asignatura/obtener-categorias-asignatura`;
    return this.http.get<ICategoriaAsignatura>(url, {headers: this.getHeaders()});
  }
  getSiglasAsignatura(anyo: number, periodoId: number,sedeId: number = 0, catAsignaturaId: number = 0): Observable<ISiglaAsignatura> {
    let qrySede: string = sedeId !== 0 ? `&sede-id=${sedeId}` : ''
    let qryCatAsignaturaId: string = catAsignaturaId !== 0 ? `&cat-asignatura-id=${catAsignaturaId}` : ''
    const url = `${environment.endpointAdministrativo}/v1/exclusion-asignatura/buscar-asignatura?anyo=${anyo}&periodo-id=${periodoId}${qrySede}${qryCatAsignaturaId}`;
    return this.http.get<ISiglaAsignatura>(url, {headers: this.getHeaders()});
  }
  getSeccion(anyo: number, periodoId: number,sedeId: number, tpoAsignaturaId: number, asignaturaId: number): Observable<ISeccion> {
    const url = `${environment.endpointAdministrativo}/v1/exclusion-asignatura/buscar-secciones?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}&cat-asignatura-id=${tpoAsignaturaId}&asignatura-id=${asignaturaId}`;
    return this.http.get<ISeccion>(url, {headers: this.getHeaders()});
  }
  postBusquedaExclusion(body: FiltrosExclusion): Observable<IBusqueda[]> {
    const url = `${environment.endpointAdministrativo}/v1/exclusion-asignatura/busqueda`;
    return this.http.post<IBusqueda[]>(url, body, { headers: this.getHeaders() });
  }
  postDescargarExclusion(body: FiltrosExclusion): Observable<IDescarga> {
    const url = `${environment.endpointAdministrativo}/v1/exclusion-asignatura/descargar`;
    return this.http.post<IDescarga>(url, body, { headers: this.getHeaders() });
  }
  postGuardarExclusionAsignaturas ( body: IGuardar[]): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/exclusion-asignatura/agregar-asignatura`;
    return this.http.post<any>(url, body, { headers: this.getHeaders() });
  }
  postExclusionMasiva ( body: IExclusionAsignaturaBody): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/exclusion-asignatura/exlusion-masiva`;
    return this.http.post<IExclusionAsignaturaRes>(url, body, { headers: this.getHeaders() });
  }

}
